import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/service/api.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-widget-container',
  templateUrl: './widget-container.component.html',
  styleUrls: ['./widget-container.component.css'],
})
export class WidgetContainerComponent implements OnInit {
  festiveForm: FormGroup;
  competitionForm: FormGroup;
  showModalFestive: boolean = false;
  festiveFormTitle: string = 'Request a Quote';
  competitionFormTitle: string = 'Request a Quote for the Winter Sale';
  successMessage: any;
  isShowModalMessage: boolean = false;
  isOpenHoursVisible: boolean = false;
  isBrowser: boolean;
  showModalCompetition: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    // Initialiser les formulaires avec TOUS les champs nécessaires
    this.festiveForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contactNumber: [''],
      message: [''], // Important : initialiser même si conditionnel
      destination: [null, Validators.required],
      travelDate: [''],
    });

    this.competitionForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contactNumber: [''],
      message: [''],
      checkConditions: [false, Validators.requiredTrue],
    });
  }

  ngOnInit(): void {}

  openModal(modalName: string): void {
    if (modalName === 'Festive') {
      this.showModalFestive = true;
      this.closeModal('OpenHours');
      this.closeModal('Competition');
      return;
    }
    if (modalName === 'Competition') {
      this.showModalCompetition = true;
      this.closeModal('OpenHours');
      this.closeModal('Festive');
      return;
    }
    if (modalName === 'OpenHours') {
      this.isOpenHoursVisible = true;
      this.closeModal('Competition');
      this.closeModal('Festive');
      return;
    }
  }

  closeModal(modalName: string): void {
    if (modalName === 'Festive') {
      this.showModalFestive = false;
      return;
    }
    if (modalName === 'Competition') {
      this.showModalCompetition = false;
      return;
    }
    if (modalName === 'message') {
      this.isShowModalMessage = false;
    }
    if (modalName === 'OpenHours') {
      this.isOpenHoursVisible = false;
      return;
    }
  }

  requestQuoteFestive(): void {
    if (this.festiveForm.valid) {
      const formData = { ...this.festiveForm.value };

      // Log pour debugging (à retirer en production)

      this.apiService.sendFestiveSaleQuote(formData).subscribe({
        next: (data) => {
          this.successMessage = data?.Message;
          this.showModalFestive = false;
          if (this.successMessage) {
            this.showModalMessage();
          }
          this.festiveForm.reset();
        },
        error: (err) => {
          console.error('Error submitting form:', err);
          this.successMessage = 'An error occurred. Please try again.';
          this.showModalMessage();
        },
      });
    } else {
      Object.keys(this.festiveForm.controls).forEach((key) => {
        this.festiveForm.controls[key].markAsTouched();
      });
    }
  }

  enterGiveAway(): void {
    if (this.competitionForm.valid) {
      const formData = { ...this.competitionForm.value };
      delete formData.checkConditions;


      this.apiService.sendChristmasGiveaway(formData).subscribe({
        next: (data) => {
          this.successMessage = data?.Message;
          this.showModalCompetition = false;
          if (this.successMessage) {
            this.showModalMessage();
          }
          this.competitionForm.reset();
        },
        error: (err) => {
          console.error('Error submitting competition:', err);
          this.successMessage =
            err?.Message || 'An error occurred. Please try again.';
          this.showModalMessage();
        },
      });
    } else {
      Object.keys(this.competitionForm.controls).forEach((key) => {
        this.competitionForm.controls[key].markAsTouched();
      });
    }
  }

  showModalMessage(): void {
    this.isShowModalMessage = true;
  }
}
